import React from 'react'
import { Text } from '../languages/Language';

export default function AGB(props) {

    return (
        <>
            <button
                className="flex items-center
        justify-center "
                type="button"
                onClick={() => props.ShowAGB(true)}
            >
                <Text tid="Terms" />
            </button>

        </>
    )
}